import React, { useEffect, useRef, useState } from "react";
import { classes } from "../../../core/data/json/classes";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import {
  activeList,
  classSection,
  classSylabus,
} from "../../../core/common/selectoption/selectoption";
import CommonSelect from "../../../core/common/commonSelect";
import { Link } from "react-router-dom";
import TooltipOption from "../../../core/common/tooltipOption";
import { all_routes } from "../../router/all_routes";
import UserService from "../../network/services/UserService";
import { getUser } from "../../network/auth/Auth";
import { Modal, Toast } from "react-bootstrap";

const Subjects = () => {
  const routes = all_routes;

  const data = classes;
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };
  const route = all_routes


  interface subjectData {
    id: any;
    name: any;
    code: any;
    grade_weightage: any;
    type: any;
    subject_type: any;
    department_id: any;
    active: any;
    operating_branch_id: any;
    company_id: any

  }
  interface Option {
    id: any;
    name: any;
  }

  const types =
    [{ value: 'theory', label: 'Theory' }, { value: 'practical', label: 'Practical' },
    { value: 'both', label: 'Both' }, { value: 'other', label: 'Other' }]

  const subject_types =
    [{ value: 'compulsory', label: 'Compulsory' }, { value: 'elective', label: 'Elective' }]


  const evaluationTypes = [{ value: 'normal', label: 'Normal' }, { value: 'GPA', label: 'GPA' },
  { value: 'CWA', label: 'CWA' }, { value: 'CCE', label: 'CCE' }];


  interface CourseData {
    id: any;
    name: any;
    code: any;
    parent_id: any;
    evaluation_type: any;
    subject_ids: any;
    department_id: any;
    active: any;
    fees_term_id: any;
    operating_branch_id: any;
    company_id: any

  }
  interface Option {
    id: any;
    name: any;
  }


  const [isActionSuccessful, setIsActionSuccessful] = useState(false);
  const [isActionSuccessfulEdit, setIsActionSuccessfulEdit] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showDangerToast, setShowDangerToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any>({
    name: '',
    code: '',
    grade_weightage: '',
    type: '',
    subject_type: '',
    operating_branch_id: '',
    company_id: ''
  });




  const handleSuccessToastClose = () => {
    setShowSuccessToast(false);
  };

  const handleDangerToastClose = () => {
    setShowDangerToast(false);
  };

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleClose2 = () => setShowModal2(false);
  const handleShow2 = () => setShowModal2(true);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowDangerToast(false);
    }, 3000);
    return () => clearTimeout(timeoutId);
  }, [showDangerToast]);


  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowSuccessToast(false);
    }, 4000);
    return () => clearTimeout(timeoutId);
  }, [showSuccessToast]);

  const [formData, setFormData] = useState({
    name: '',
    code: '',
    grade_weightage: '',
    type: '',
    subject_type: '',
    operating_branch_id: '',
    company_id: ''
  });


  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleInputChangeEdite = (e: any) => {
    const { name, value } = e.target;
    setSelectedRecord((prevRecord: any) => ({
      ...prevRecord,
      [name]: value
    }));
  };

  const handleInputChangeEdite2 = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target;
    const selectedBranch = branches.find((branch: any) => branch.id === parseInt(value, 10));

    if (selectedBranch) {
      setSelectedRecord((prevState: any) => ({
        ...prevState,
        operating_branch_id: [selectedBranch],
      }));
    }
  };

  const handleInputChangeEdite3 = (selectedOptions: any) => {
    if (selectedOptions) {
      const selectedSubjects = selectedOptions.map((option: any) => ({
        id: option.value,
        name: option.label,
      }));

      setSelectedRecord((prevState: any) => ({
        ...prevState,
        subject_ids: selectedSubjects,
      }));
    } else {
      setSelectedRecord((prevState: any) => ({
        ...prevState,
        subject_ids: [],
      }));
    }
  };



  const handleSelectChange = (selectedOption: any, actionMeta: any) => {

    setFormData({
      ...formData,
      [actionMeta.name]: selectedOption
    });
  };



  const handleEdit = (record: any) => {
    setSelectedRecord(record)
    handleShow2()

    console.log(record)
  };




  const handleSubmit = () => {
    setIsLoading(true)


    const request_data = {
      name: formData.name,
      code: formData.code,
      grade_weightage: parseFloat(formData.grade_weightage),
      type: formData.type,
      subject_type: formData.subject_type,
      company_id: getUser()?.company_ids[0]?.id,
      operating_branch_id: formData.operating_branch_id === "" ? getUser()?.company_ids[0]?.branches[0]?.id : parseInt(formData.operating_branch_id, 10),
    };

    UserService.addSubject(request_data, (response: any) => {
      if (response.data && response.success) {
        fetchData(getUser()?.company_ids[0]?.branches[0]?.id, getUser()?.company_ids[0]?.id, branch);
        setIsLoading(false)
        setIsActionSuccessful(true)
        setSuccessMessage('Data saved successfully')
        setShowSuccessToast(true)
        setFormData({
          name: '',
          code: '',
          grade_weightage: '',
          type: '',
          subject_type: '',
          operating_branch_id: '',
          company_id: ''
        });

        setShowModal(false);

      } else {
        setErrorMessage('An error has occurred, please try again.')
        setShowDangerToast(true)
        setIsLoading(false)
      }
    });
  };

  const handleSubmitEdit = () => {
    console.log(selectedRecord)


    setIsLoading(true)
    const request_data = {

      name: selectedRecord.name,
      code: selectedRecord.code,
      grade_weightage: parseFloat(selectedRecord.grade_weightage),
      type: selectedRecord.type,
      subject_type: selectedRecord.subject_type,
      company_id: getUser()?.company_ids[0]?.id,
      operating_branch_id: selectedRecord?.operating_branch_id?.[0]?.id === undefined ? parseInt(selectedRecord?.operating_branch_id?.[0]?.id, 10) : parseInt(selectedRecord?.operating_branch_id?.[0]?.id, 10),
    };
    console.log(request_data)


    UserService.editSubject(selectedRecord?.id, request_data, (response: any) => {
      if (response.data && response.success) {
        fetchData(getUser()?.company_ids[0]?.branches[0]?.id, getUser()?.company_ids[0]?.id, branch);
        setIsLoading(false)
        setIsActionSuccessfulEdit(true)
        handleClose2()
      } else {

        setErrorMessage('An error has occurred, please try again.')
        setShowDangerToast(true)
        setIsLoading(false)
      }
    });
  };

  const formatDate = (date: Date | string) => {
    if (!date) return '';

    const d = new Date(date);
    const month = `${d.getMonth() + 1}`.padStart(2, '0');
    const day = `${d.getDate()}`.padStart(2, '0');
    const year = d.getFullYear();

    return `${year}-${month}-${day}`;
  };

















  const [subjects, setSubjects] = useState<subjectData[]>([]);
  const [branch, setBranch] = useState<any>();
  const branches = getUser()?.company_ids[0]?.branches;



  const fetchData = async (branch_id: any, company_id: any, item: any) => {
    if (item) {
      setBranch(item.name);
    }
    UserService.getSubjectsByBranchAndComapny(branch_id, company_id, (response: any) => {
      if (response?.data && response?.success) {
        setSubjects(response.data);
      } else {
        setSubjects([])
      }
    });
  };

  const fetchDataInit = async (company_id: any) => {
    setBranch('All');
    UserService.getSubjectsByBranchAndComapnyAll(company_id, (response: any) => {
      if (response?.data && response?.success) {
        setSubjects(response.data);

      } else {
        setSubjects([]);
      }
    });
  };

  useEffect(() => {
    fetchDataInit(getUser()?.company_ids[0]?.id);

  }, []);



  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      render: (text: string, record: any, index: number) => (
        <>
          <Link to="#" className="link-primary">
            {record.id}
          </Link>
        </>
      ),
    },

    {
      title: "Name",
      dataIndex: "name",
      sorter: (a: subjectData, b: subjectData) => a.name.length - b.name.length,
    },
    {
      title: "Code",
      dataIndex: "code",
      sorter: (a: subjectData, b: subjectData) =>
        a.code.length - b.code.length,
    },
    {
      title: "Type",
      dataIndex: "type",
      sorter: (a: subjectData, b: subjectData) =>
        a.type.length - b.type.length,
    },
    {
      title: "Subject Type",
      dataIndex: "subject_type",
      sorter: (a: subjectData, b: subjectData) =>
        a.subject_type.length - b.subject_type.length,
    },
    {
      title: "Grade Weightage",
      dataIndex: "grade_weightage",
      sorter: (a: subjectData, b: subjectData) =>
        a.grade_weightage.length - b.grade_weightage.length,
    },

    {
      title: "Branhe",
      dataIndex: "operating_branch_id",
      render: (record: any) => (
        <>
          {record && record?.map((item: any, index: any) => (
            <span className="">

              {item.name}
            </span>
          ))}

        </>
      ),
      sorter: (a: subjectData, b: subjectData) =>
        a.operating_branch_id.length - b.operating_branch_id.length,
    },
    {
      title: "Company",
      dataIndex: "company_id",
      render: (record: any) => (
        <>
          {record && record?.map((item: any, inex: any) => (
            <span className="">

              {item.name}
            </span>
          ))}

        </>
      ),
      sorter: (a: subjectData, b: subjectData) =>
        a.company_id.length - b.company_id.length,
    },
    {
      title: "Status",
      dataIndex: "active",
      render: (record: any) => (
        <>
          {record ? (
            <span className="badge badge-soft-success d-inline-flex align-items-center">
              <i className="ti ti-circle-filled fs-5 me-1"></i>
              Active
            </span>
          ) : (
            <span className="badge badge-soft-danger d-inline-flex align-items-center">
              <i className="ti ti-circle-filled fs-5 me-1"></i>
              Inactive
            </span>
          )}
        </>
      ),
    },
    {
      title: "Action",

      render: (record: any) => (
        <>
          <div className="d-flex align-items-center">
            <div className="dropdown">
              <Link
                to="#"
                className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="ti ti-dots-vertical fs-14" />
              </Link>
              <ul className="dropdown-menu dropdown-menu-right p-3">
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    onClick={() => handleEdit(record)}
                  >
                    <i className="ti ti-edit-circle me-2" />
                    Edit
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#delete-modal"
                  >
                    <i className="ti ti-trash-x me-2" />
                    Delete
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </>
      ),
    },
  ];
  return (
    <div>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Subject List</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={route.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">Subjects </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    All Subjects
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />

              {getUser().role === "school_admin" && (<div className="mb-2">
                <Link to="#" className="btn btn-primary d-flex align-items-center" onClick={handleShow}>
                  <i className="ti ti-square-rounded-plus me-2" />
                  Add Subject
                </Link>

              </div>)}

            </div>
          </div>
          {/* /Page Header */}
          {/* Guardians List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Subject List</h4>
              <div className="d-flex align-items-center flex-wrap">
                <div className="input-icon-start mb-3 me-2 position-relative">
                  <PredefinedDateRanges />
                </div>
                <div className="dropdown mb-3 me-2">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                  >
                    <i className="ti ti-filter me-2" />
                    Filter
                  </Link>
                  <div className="dropdown-menu drop-width" ref={dropdownMenuRef}>
                    <form >
                      <div className="d-flex align-items-center border-bottom p-3">
                        <h4>Filter</h4>
                      </div>
                      <div className="p-3 border-bottom pb-0">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Class</label>
                              <CommonSelect
                                className="select"
                                options={classSylabus}
                                defaultValue={classSylabus[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Section</label>
                              <CommonSelect
                                className="select"
                                options={classSection}
                                defaultValue={classSection[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Status</label>
                              <CommonSelect
                                className="select"
                                options={activeList}
                                defaultValue={activeList[0]}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="p-3 d-flex align-items-center justify-content-end">
                        <Link to="#" className="btn btn-light me-3">
                          Reset
                        </Link>
                        <Link
                          to="#"
                          className="btn btn-primary"
                          onClick={handleApplyClick}
                        >
                          Apply
                        </Link>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="dropdown mb-3">
                  <Link to="#" className="btn btn-outline-light bg-white dropdown-toggle" data-bs-toggle="dropdown">
                    <i className="ti ti-sort-ascending-2 me-2" />
                    {branch}
                  </Link>
                  <ul className="dropdown-menu p-3">
                    <li >
                      <a className="dropdown-item rounded-1" onClick={() => fetchDataInit(getUser()?.company_ids[0]?.id)}>
                        All
                      </a>
                    </li>
                    {branches?.map((item: any) => (
                      <li key={item.id}>
                        <a className="dropdown-item rounded-1" onClick={() => fetchData(item.id, getUser()?.company_ids[0]?.id, item)}>
                          {item.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* Guardians List */}
              <Table columns={columns} dataSource={subjects} Selection={true} />
              {/* /Guardians List */}
            </div>
          </div>
          {/* /Guardians List */}
        </div>
      </div>
      ;{/* /Page Wrapper */}
      <>
        {/* Add Classes */}
        <div className="modal fade" id="add_class">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add Class</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Class Name</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Section</label>
                        <CommonSelect
                          className="select"
                          options={classSection}
                          defaultValue={classSection[0]}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">No of Students</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">No of Subjects</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="status-title">
                          <h5>Status</h5>
                          <p>Change the Status by toggle </p>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="switch-sm"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link to="#" className="btn btn-primary" data-bs-dismiss="modal">
                    Add Class
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Add Classes */}
        {/* Edit Classes */}
        <div className="modal fade" id="edit_class">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Edit Class</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form >
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Class Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Class Name"
                          defaultValue="I"
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Section</label>
                        <CommonSelect
                          className="select"
                          options={classSection}
                          defaultValue={classSection[0]}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">No of Students</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter no of Students"
                          defaultValue={30}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">No of Subjects</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter no of Subjects"
                        // defaultValue={03}
                        />
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="status-title">
                          <h5>Status</h5>
                          <p>Change the Status by toggle </p>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="switch-sm2"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link to="#" className="btn btn-primary" data-bs-dismiss="modal">
                    Save Changes
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Edit Classes */}
        {/* Delete Modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form >
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete all the marked items, this cant be undone
                    once you delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link to="#" className="btn btn-danger" data-bs-dismiss="modal"
                    >
                      Yes, Delete
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}
        {/* View Classes */}
        <div className="modal fade" id="view_class">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <div className="d-flex align-items-center">
                  <h4 className="modal-title">Class Details</h4>
                  <span className="badge badge-soft-success ms-2">
                    <i className="ti ti-circle-filled me-1 fs-5" />
                    Active
                  </span>
                </div>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form >
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="class-detail-info">
                        <p>Class Name</p>
                        <span>III</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="class-detail-info">
                        <p>Section</p>
                        <span>A</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="class-detail-info">
                        <p>No of Subjects</p>
                        <span>05</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="class-detail-info">
                        <p>No of Students</p>
                        <span>25</span>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /View Classes */}




        <Modal show={showModal} onHide={handleClose} >
          <Modal.Header >
            <Modal.Title>Add Course</Modal.Title>
            <button
              type="button"
              className="btn-close custom-btn-close"
              onClick={handleClose}

            >
              <i className="ti ti-x" />
            </button>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Name</label>
                      <input type="text" className="form-control" placeholder="Name" name="name" value={formData.name}
                        onChange={handleInputChange} />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Code</label>
                      <input type="text" className="form-control" name="code" value={formData.code}
                        onChange={handleInputChange} />

                    </div>
                    <div className="mb-3">
                      <label className="form-label">Grade Weightage</label>
                      <input type="number" className="form-control" name="grade_weightage"
                        value={formData.grade_weightage}
                        onChange={handleInputChange} />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Type</label>
                      <select

                        className="select react-select form-control"
                        name="type"
                        onChange={handleInputChange}
                      >
                        <option >Select Type</option>
                        {types && types?.map((item: any) => (
                          <option key={item.value} value={item.value}>{item.label}</option>
                        ))}

                      </select>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Subject Type</label>
                      <select

                        className="select react-select form-control"
                        name="subject_type"
                        onChange={handleInputChange}
                      >
                        <option >Select Subject Type</option>
                        {subject_types && subject_types?.map((item: any) => (
                          <option key={item.value} value={item.value}>{item.label}</option>
                        ))}

                      </select>
                    </div>


                    <div className="mb-3">
                      <label className="form-label">Branch</label>
                      <select

                        className="select react-select form-control"
                        name="operating_branch_id"
                        onChange={handleInputChange}
                      >
                        <option >Select Branch</option>
                        {branches && branches?.map((item: any) => (
                          <option key={item.id} value={item.id}>{item.name}</option>
                        ))}

                      </select>
                    </div>


                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <span
                  className="btn btn-light me-2"
                  onClick={handleClose}
                >
                  Cancel
                </span>
                <a className="btn btn-primary" onClick={handleSubmit}  >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm align-middle me-1"
                        role="status"
                        aria-hidden="true"
                      />
                      Loading...
                    </>
                  ) : "Add Course"}

                </a>
              </div>
            </form>
          </Modal.Body>

        </Modal>

        <Modal show={showModal2} onHide={handleClose2} >
          <Modal.Header >
            <Modal.Title>Edit Course</Modal.Title>
            <button
              type="button"
              className="btn-close custom-btn-close"
              onClick={handleClose2}

            >
              <i className="ti ti-x" />
            </button>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Name</label>
                      <input type="text" className="form-control" placeholder="Name" name="name" value={selectedRecord?.name}
                        onChange={handleInputChangeEdite} />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Code</label>
                      <input type="text" className="form-control" name="code" value={selectedRecord.code}
                        onChange={handleInputChangeEdite} />

                    </div>
                    <div className="mb-3">
                      <label className="form-label">Grade Weightage</label>
                      <input type="number" className="form-control" name="grade_weightage"
                        value={selectedRecord.grade_weightage}
                        onChange={handleInputChangeEdite} />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Type</label>
                      <select

                        className="select react-select form-control"
                        name="type"
                        value={selectedRecord.type}
                        onChange={handleInputChangeEdite}
                      >
                        <option >Select Type</option>
                        {types && types?.map((item: any) => (
                          <option key={item.value} value={item.value}>{item.label}</option>
                        ))}

                      </select>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Subject Type</label>
                      <select

                        className="select react-select form-control"
                        name="subject_type"
                        value={selectedRecord.subject_type}
                        onChange={handleInputChangeEdite}
                      >
                        <option >Select Subject Type</option>
                        {subject_types && subject_types?.map((item: any) => (
                          <option key={item.value} value={item.value}>{item.label}</option>
                        ))}

                      </select>
                    </div>


                    <div className="mb-3">
                      <label className="form-label">Branch</label>
                      <select
                        className="select react-select form-control"
                        name="operating_branch_id"
                        value={selectedRecord?.operating_branch_id?.[0]?.id || ''}// Assurez-vous que cette valeur correspond à une option
                        onChange={handleInputChangeEdite2}
                      >
                        {branches && branches.map((item: any) => (
                          <option value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>

                    </div>


                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <span
                  className="btn btn-light me-2"
                  onClick={handleClose2}
                >
                  Cancel
                </span>
                <Link to="#" className="btn btn-primary" onClick={handleSubmitEdit}  >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm align-middle me-1"
                        role="status"
                        aria-hidden="true"
                      />
                      Loading...
                    </>
                  ) : "Edit Course"}

                </Link>
              </div>
            </form>
          </Modal.Body>

        </Modal>

        <Toast
          show={showDangerToast}
          onClose={handleDangerToastClose}
          id="dangerToast"
          className="toast-container position-fixed top-0 end-0 p-3 colored-toast bg-danger-transparent"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          style={{ minWidth: "200px!important" }}
        >
          <Toast.Header closeButton className="bg-danger text-fixed-white">
            <strong className="me-auto">Message</strong>
            <span
              className="cursor-pointer"
              onClick={handleDangerToastClose}
              aria-label="Close"
              style={{ cursor: "pointer" }}
            />
          </Toast.Header>
          <Toast.Body>
            {/* Add your toast content here */}
            {errorMessage}
          </Toast.Body>
        </Toast>

        <Toast
          show={showSuccessToast}
          onClose={handleSuccessToastClose}
          id="successToast"
          className="toast-container position-fixed top-0 end-0 p-3  colored-toast bg-success-transparent"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >

          <Toast.Body>
            {/* Add your toast content here */}
            {successMessage}
          </Toast.Body>
        </Toast>
      </>
    </div>
  );
};

export default Subjects;
